import React from "react";
import { IoIosAddCircleOutline } from "react-icons/io";

const AnotherAccount = ({ buttonName, onClick }) => {
  return (
    <div>
      <button
        className="flex gap-2 items-center pb-2 md:mt-6 lg:mt-10 mt-6  ml-2 rounded-lg  justify-center font-semibold text-[#FF6B00]"
        onClick={onClick}
      >
        <IoIosAddCircleOutline className="text-lg" />
        {buttonName}
      </button>
    </div>
  );
};
export default AnotherAccount;
